import { ServiceHistoryService } from 'api-new/generated';
import { useQuery } from 'react-query';

export const SERVICE_HISTORY_VAUXHALL_QUERY_KEY = 'ServiceHistoryVauxhallQuery';

export const useServiceHistoryVauxhallQuery = (params: { serviceHistoryId: number }, options?: { enabled?: boolean }) =>
  useQuery(
    [SERVICE_HISTORY_VAUXHALL_QUERY_KEY, params.serviceHistoryId],
    () => ServiceHistoryService.getServiceHistoryVauxhall(params.serviceHistoryId),
    {
      enabled: !!params.serviceHistoryId && options?.enabled !== false
    }
  );
